import { render } from "./QuizBlock.vue?vue&type=template&id=11053b60"
import script from "./QuizBlock.vue?vue&type=script&lang=js"
export * from "./QuizBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__